[
  {
    "id": "MET-E8P-L306-001",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een cilinder heeft een straal van 10 cm en een hoogte van 20 cm. Wat is de inhoud in liters? (π = 3,14)",
    "options": ["6,28 liter", "62,8 liter", "3,14 liter", "12,56 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-CILINDER",
    "explanation": "Grondvlak = π × r² = 3,14 × 100 = 314 cm². Inhoud = 314 × 20 = 6.280 cm³ = 6,28 liter.",
    "distractorExplanations": {
      "1": "Je vergat te delen door 1.000.",
      "2": "Je deed de inhoud : 2.",
      "3": "Je deed de inhoud × 2."
    }
  },
  {
    "id": "MET-E8P-L306-002",
    "module": "Metriek",
    "difficulty": 306,
    "question": "De lichtsnelheid is 300.000 km/s. Hoe ver reist licht in 1 minuut?",
    "options": ["18.000.000 km", "300.000 km", "1.800.000 km", "3.000.000 km"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-LICHT",
    "explanation": "300.000 × 60 = 18.000.000 km.",
    "distractorExplanations": {
      "1": "Dat is in 1 seconde.",
      "2": "Een nul te weinig.",
      "3": "Je deed ×10."
    }
  },
  {
    "id": "MET-E8P-L306-003",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Reken om: 5 knopen = ... km/u (1 zeemijl = 1,852 km)",
    "options": ["9,26 km/u", "5 km/u", "10 km/u", "1,852 km/u"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-KNOPEN",
    "explanation": "5 × 1,852 = 9,26 km/u.",
    "distractorExplanations": {
      "1": "Je zette niets om.",
      "2": "Schattingsfout.",
      "3": "Dat is 1 knoop."
    }
  },
  {
    "id": "MET-E8P-L306-004",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een gouden staaf van 1 dm³ weegt 19,3 kg. Wat is het soortelijk gewicht in g/cm³?",
    "options": ["19,3 g/cm³", "1,93 g/cm³", "193 g/cm³", "0,193 g/cm³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-SG-GOUD",
    "explanation": "kg/dm³ is hetzelfde getal als g/cm³. Dus 19,3 kg/dm³ = 19,3 g/cm³.",
    "distractorExplanations": {
      "1": "Je deelde door 10.",
      "2": "Je deed ×10.",
      "3": "Je deelde door 100."
    }
  },
  {
    "id": "MET-E8P-L306-005",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Hoeveel mm³ is 0,0001 liter?",
    "options": ["100 mm³", "10 mm³", "1 mm³", "1.000 mm³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-L-MM3",
    "explanation": "0,0001 liter = 0,1 ml = 0,1 cm³ = 100 mm³.",
    "distractorExplanations": {
      "1": "Een nul te weinig.",
      "2": "Twee nullen te weinig.",
      "3": "Een nul te veel."
    }
  },
  {
    "id": "MET-E8P-L306-006",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een kegel heeft een grondvlak van 50 cm² en een hoogte van 12 cm. Wat is de inhoud? (inhoud kegel = $\\frac{1}{3}$ × grondvlak × hoogte)",
    "options": ["200 cm³", "600 cm³", "100 cm³", "300 cm³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-KEGEL",
    "explanation": "Inhoud kegel = $\\frac{1}{3}$ × 50 × 12 = $\\frac{1}{3}$ × 600 = 200 cm³.",
    "distractorExplanations": {
      "1": "Je bent vergeten te delen door 3.",
      "2": "Je deelde door 6 in plaats van 3.",
      "3": "Je deed $\\frac{1}{2}$ × 600."
    }
  },
  {
    "id": "MET-E8P-L306-007",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een zwembad van 25 m × 10 m × 1,5 m wordt gevuld met een slang van 500 liter per minuut. Hoe lang duurt het vullen in uren?",
    "options": ["12,5 uur", "6,25 uur", "25 uur", "750 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-VULLEN-ZWEMBAD",
    "explanation": "Inhoud: 25 × 10 × 1,5 = 375 m³ = 375.000 liter. Tijd: 375.000 : 500 = 750 minuten = 12,5 uur.",
    "distractorExplanations": {
      "1": "Je deed 375 : 500 × 60.",
      "2": "Je deed 750 : 30.",
      "3": "Dat is het aantal minuten."
    }
  },
  {
    "id": "MET-E8P-L306-008",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een blok ijs van 2 dm³ weegt 1,84 kg. Wat is het soortelijk gewicht van ijs in kg/dm³?",
    "options": ["0,92 kg/dm³", "1,84 kg/dm³", "3,68 kg/dm³", "0,46 kg/dm³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-SG-IJS",
    "explanation": "Soortelijk gewicht = massa : volume = 1,84 : 2 = 0,92 kg/dm³.",
    "distractorExplanations": {
      "1": "Dat is het totale gewicht, niet per dm³.",
      "2": "Je deed 1,84 × 2.",
      "3": "Je deed 1,84 : 4."
    }
  },
  {
    "id": "MET-E8P-L306-009",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Reken om: 45 m/s = ... km/u",
    "options": ["162 km/u", "45 km/u", "450 km/u", "135 km/u"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-MS-KMU-45",
    "explanation": "Van m/s naar km/u: ×3,6. 45 × 3,6 = 162 km/u.",
    "distractorExplanations": {
      "1": "Je zette niets om.",
      "2": "Je deed ×10.",
      "3": "Je deed ×3."
    }
  },
  {
    "id": "MET-E8P-L306-010",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een bak van 2 m × 1 m × 0,5 m is gevuld met olie. Olie weegt 0,8 kg per liter. Hoeveel kg weegt de olie?",
    "options": ["800 kg", "1.000 kg", "500 kg", "80 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-SG-OLIE",
    "explanation": "Inhoud: 2 × 1 × 0,5 = 1 m³ = 1.000 liter. 1.000 × 0,8 = 800 kg.",
    "distractorExplanations": {
      "1": "Dat is als olie 1 kg/liter woog (water).",
      "2": "Je deed 1.000 × 0,5.",
      "3": "Je vergat om te rekenen naar liter."
    }
  },
  {
    "id": "MET-E8P-L306-011",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een cirkel heeft een oppervlakte van 706,5 cm². Wat is de diameter? (π = 3,14)",
    "options": ["30 cm", "15 cm", "45 cm", "60 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-CIRKEL-DIAMETER",
    "explanation": "Oppervlakte = π × r². 706,5 : 3,14 = 225. r² = 225. r = 15 cm. Diameter = 2 × 15 = 30 cm.",
    "distractorExplanations": {
      "1": "Dat is de straal.",
      "2": "Je deed 15 × 3.",
      "3": "Je deed 30 × 2."
    }
  },
  {
    "id": "MET-E8P-L306-012",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Reken om: 0,000003 km³ = ... liter",
    "options": ["3.000.000 liter", "3.000 liter", "300.000 liter", "30.000.000 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-KM3-L",
    "explanation": "1 km³ = 10⁹ m³. 0,000003 × 10⁹ = 3.000 m³. 3.000 × 1.000 = 3.000.000 liter.",
    "distractorExplanations": {
      "1": "Je vergat om te rekenen naar liter.",
      "2": "Je deed maar één stap.",
      "3": "Je deed een nul te veel."
    }
  },
  {
    "id": "MET-E8P-L306-013",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een piramide heeft een vierkant grondvlak van 6 × 6 cm en een hoogte van 10 cm. Wat is de inhoud? (inhoud = $\\frac{1}{3}$ × grondvlak × hoogte)",
    "options": ["120 cm³", "360 cm³", "60 cm³", "180 cm³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-PIRAMIDE",
    "explanation": "Grondvlak = 6 × 6 = 36 cm². Inhoud = $\\frac{1}{3}$ × 36 × 10 = $\\frac{1}{3}$ × 360 = 120 cm³.",
    "distractorExplanations": {
      "1": "Je bent vergeten te delen door 3.",
      "2": "Je deelde door 6.",
      "3": "Je deed $\\frac{1}{2}$ × 360."
    }
  },
  {
    "id": "MET-E8P-L306-014",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een vliegtuig vliegt 900 km/u. Hoeveel meter per seconde is dat?",
    "options": ["250 m/s", "90 m/s", "900 m/s", "150 m/s"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-VLIEGTUIG-MS",
    "explanation": "Van km/u naar m/s: delen door 3,6. 900 : 3,6 = 250 m/s.",
    "distractorExplanations": {
      "1": "Je deelde door 10.",
      "2": "Je zette niets om.",
      "3": "Je deelde door 6."
    }
  },
  {
    "id": "MET-E8P-L306-015",
    "module": "Metriek",
    "difficulty": 306,
    "question": "Een kubus van ijs (0,92 kg/dm³) heeft zijden van 5 dm. Hoeveel kg weegt de kubus?",
    "options": ["115 kg", "23 kg", "125 kg", "92 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-KUBUS-IJS",
    "explanation": "Inhoud = 5 × 5 × 5 = 125 dm³. 125 × 0,92 = 115 kg.",
    "distractorExplanations": {
      "1": "Je deed 25 × 0,92.",
      "2": "Dat is het volume, niet het gewicht.",
      "3": "Je deed 100 × 0,92."
    }
  }
]